/**
 * Payment Controller
 */
bookingApp.controller('paymentController', function($scope, $http, $window, $document, $timeout, $interval, $q, PaymentManagerFactory, sessionFactory){
    // setup footer controls
    // setup footer control functionality
    if($scope.property.isItemOnly){
        $scope.setupItemOnlyFooter();
    } else {
        $scope.setupStandardCartFooter();
    }
    $scope.footer.nextFunc = function(){
        $scope.paymentHandler.start();
    };

    $scope.confirmBooking = function(paymentRef){
        var data = {
            sid: $scope.session.sid,
            device: 'mobile',
            format: 'json'
        };
        if(paymentRef !== undefined) {
            data.payRef = paymentRef;
        }
        // process the booking to confirm
        $scope.session.isLoading = true;
        // post the data through to the cart
        $http.post('/front-booking/api-confirm-booking/', data).success(function(data, status, headers, config) {
            // add the transaction to google analytics tracker
            if(data.hasOwnProperty('transactions') && data.hasOwnProperty('items')) {
                $scope.triggerConfirmationTracking(data.transactions, data.items);
            }
            $scope.goToPage('confirmation');
        }).error(function(data, status, headers, config) {
            // log the error
            $scope.logError('Error confirming booking',{status: status, headers: headers});
            $scope.showError('Error Confirming Booking','Booking couldn\'t be confirmed. Please retry, if the problem persists please refresh your browser or use the desktop version', true);
            // hide the loader
            $scope.session.isLoading = false;
        });

    };

    // payment handler
    $scope.paymentHandler = {
        managers: {},
        focusTimeoutPromise: null,
        countdownTimerPromise: null,
        currentStatus: false,
        getConfig: function() {
            return $scope.session.payment;
        },
        reset: function() {
            this.focusTimeoutPromise = null;
            this.currentStatus = false;
        },
        manager: function() {
            var config = this.getConfig().config,
                id = config.paymentRef;

            if(!this.managers.hasOwnProperty(id)) {
                this.managers[id] = PaymentManagerFactory.get(config);
            }
            return this.managers[id];
        },
        start: function() {
            // Setup a payment manager
            var manager = this.manager(),
                completionDefer = $q.defer(),
                self = this;

            // Mark scope as loading
            $scope.session.isLoading = true;

            this.toggleFocusWatcher();

            // Bind listeners to the manager
            manager.setCallbackComplete(function (status) {
                // Give the outer scope the status
                self.currentStatus = status;
                // Cancel the timer
                self.cancelTimer();
                // Check the status of the payment
                if (status.status === 0) { // Zero is a success
                    completionDefer.resolve();
                }
                else {
                    completionDefer.reject();
                }
            });
            manager.setCallbackPending(function (status) {
                var waitTime = (status.maxPendingTime * 1000) + 3000;
                // Give the outer scope the status
                self.currentStatus = status;
                // Create a timeout until the deferred is automatically rejected
                self.focusTimeoutPromise = $timeout(function () {
                    completionDefer.reject();
                }, waitTime);
                // Hide the return to payment bubble and prevent it from showing
                self.toggleRestorePopupMessage(false);
                self.toggleFocusWatcher(false);
                // Start the timer for checking the payment details
                self.startTimer(waitTime);
            });

            // Now bind some completions to the promise object created from the deferred process above
            completionDefer.promise.then(function () {
                // Run the confirm booking stuff which will take care of the rest
                $scope.confirmBooking(parseInt(self.getConfig().config.paymentRef, 10));
            }, function () {
                // Failure means we'll have to retry. We'll have to request a new payment from the server
                // Show an error first
                var message;
                if(self.currentStatus.status === -1) { // Pending - no response from server...
                    message = 'Payment failed for an unknown reason. If this problem persists please refresh your ' +
                              'browser.';
                }
                else if(self.currentStatus.status === 1) { // DECLINED - We'll make a nicer message
                    message = 'Payment was <strong>declined</strong>. Please try again';
                }
                else {
                    message = self.currentStatus.statusMsg;
                }

                var complete = function() {
                    if(self.currentStatus.status === 5) {
                        $scope.goToCart();
                    }
                    else {
                        // Fetch a new payment request
                        self.fetchNewPaymentRequest().then(function() {
                            // Stop the loading
                            $scope.session.isLoading = false;
                            // Then show an error about the payment failing.
                            $scope.showError('Payment Incomplete', message, true);
                        });
                    }
                };

                if(self.countdownTimerPromise) {
                    self.countdownTimerPromise.finally(complete);
                }
                else {
                    complete();
                }
            }).finally(function() {
                self.toggleRestorePopupMessage(false);
                self.toggleFocusWatcher(false);
            });

            // Open the payment window
            manager.openPaymentWindow();
        },
        restorePopup: function() {
            var self = this;
            this.toggleFocusWatcher(false);
            this.toggleRestorePopupMessage(false);
            $timeout(function() {
                self.toggleFocusWatcher(true);
            }, 500);
            this.manager().gotoPaymentWindow();
        },
        toggleRestorePopupMessage: function(show) {
            if(show === undefined) {
                show = !$scope.session.loadingWarning.show;
            }
            // We'll only show the bubble if the payment status is blank (ie. not pending)
            if(this.currentStatus !== false) {
                show = false;
            }

            if(show) {
                $scope.session.loadingWarning.show = true;
                $scope.session.loadingWarning.warning = 'return-to-payment';
            }
            else {
                if($scope.session.loadingWarning.warning === 'return-to-payment') {
                    $scope.session.loadingWarning.show = false;
                    $scope.session.loadingWarning.warning = null;
                }
            }
        },
        toggleFocusWatcher: function(attach) {
            var self = this,
                documentIsHidden = $document.prop('hidden'),
                hiddenNow,
                focusFunc = function () {
                    // Set a timeout for a message that we'll show to prompt the user to return to the payment modal. We cannot
                    // auto focus the payment window as modern browsers require interaction (eg. a button click) in order to
                    // do that sort of interaction with popups.
                    if(self.focusTimeoutPromise !== false) {
                        $timeout.cancel(self.focusTimeoutPromise);
                    }
                    self.focusTimeoutPromise = $timeout(function () {
                        self.toggleRestorePopupMessage(true);
                    }, 2500)
                },
                blurFunc = function() {
                    self.toggleRestorePopupMessage(false);
                    $timeout.cancel(self.focusTimeoutPromise);
                };

            if(attach === undefined) {
                attach = true;
            }
            if(attach) {
                // Attach a listener to a change in window focus
                $window.onfocus = focusFunc;
                $window.onblur = blurFunc;
                $document.on('visibilitychange', function() {
                    hiddenNow = $(this).prop('hidden');
                    if(hiddenNow !== documentIsHidden) {
                        if(hiddenNow) {
                            blurFunc();
                        }
                        else {
                            focusFunc();
                        }
                        documentIsHidden = hiddenNow;
                    }
                });
            }
            else {
                $window.onfocus = function() { };
                $window.onblur = function() { };
                $document.off('visibilitychange');
                $timeout.cancel(this.focusTimeoutPromise);
            }
        },
        fetchNewPaymentRequest: function() {
            var self = this;
            return $http.get('/front-booking/new-payment-request?format=json&sid=' + $scope.session.sid)
                .then(function(response) {
                    self.reset();
                    console.log('response.data.payment: ',response.data.payment);
                    $scope.session.payment = response.data.payment;
                });
        },
        startTimer: function(time) {
            // Get the number of intervals to run
            var self = this,
                count = Math.ceil(time / 50),
                increment = 100 / count,
                reset = function() {
                    $scope.session.loadingWarning.warning = null;
                    $scope.session.loadingWarning.show = false;
                    $scope.session.timer.payment = {
                        progress: 0,
                        complete: true
                    };
                    self.countdownTimerPromise = null;
                };

            // Mark the timer as started
            $scope.session.loadingWarning.warning = 'checking-payment';
            $scope.session.loadingWarning.show = true;
            $scope.session.timer.payment.complete = false;

            // Create the interval
            this.countdownTimerPromise = $interval(function() {
                // Move the progress around an amount
                $scope.session.timer.payment.progress += increment;
            }, 50, count);

            // Set the completion process
            this.countdownTimerPromise.then(function() {
                // Completed without cancelling means we can just reset it
                reset();
            }, function() {
                // Otherwise we'll spin around the remaining amount before hiding
                var leftAt = $scope.session.timer.payment.progress,
                    remaining = 100 - leftAt,
                    increment = remaining / 24;

                self.countdownTimerPromise = $interval(function() {
                    $scope.session.timer.payment.progress += increment;
                }, 50, 24).then(function() {
                    reset();
                });
            });
        },
        cancelTimer: function() {
            $interval.cancel(this.countdownTimerPromise);
        }
    };

    if($scope.session.payment.required){
        //$scope.baseApp.controls.type = 'to-pay-gate';
        $scope.footer.nextFunc = function(){
            $scope.paymentHandler.start();
        };


        if($scope.session.hasOwnProperty('payment')) {
            $scope.service = $scope.session.payment.display;
        }
    }
    else {
        //$scope.baseApp.controls.type = 'skip-pay-gate';
        $scope.footer.nextFunc = function(){
            $scope.confirmBooking();
        };
    }
    $scope.promoCodeError = '';
    $scope.promoCode = {};
    $scope.promoCode.userInput = '';
    $scope.validatePromoCode = validatePromoCode;

    $scope.$watch('session.isDepositOrFullPayment', function(newVal){
        if(parseInt(sessionFactory.isDepositOrFullPayment) === 1){
            // partial payment
            sessionFactory.payment.amount = sessionFactory.suggestedDeposit;
        } else {
            // Making sure there is credit card fee
            creditCardFee = typeof sessionFactory.payment.creditCardFee === 'undefined' ? 0 : sessionFactory.payment.creditCardFee.price;
            // full payment
            sessionFactory.payment.amount = $scope.getCartRoomTotal() + creditCardFee + sessionFactory.getPromoCodeDiscountTotal();
        }
    });

    function validatePromoCode(){
        sessionFactory.isLoading = true;

        $http.post('/front-booking/api-check-promo-code', {
            'promoCode': $scope.promoCode.userInput,
            'sid': sessionFactory.sid
        })
        .success(function(data, status, headers, config){
            sessionFactory.isLoading = false;
            sessionFactory.promoWasValid = true;
            sessionFactory.payment = data.payment;
            // remove any previous errors
            $scope.promoCodeError = '';
            // update the deposit amount
            sessionFactory.suggestedDeposit = data.deposit;
            // add the discounts under the mandatory extras - or the discounts section
            sessionFactory.promoCodeDiscounts.push(data.extraTotal);
            sessionFactory.discountLabel =  data.discountLabel;
            sessionFactory.usedPromoCodes.push($scope.promoCode.userInput);
        })
        .error(function(data, status, headers, config){
            sessionFactory.isLoading = false;
            sessionFactory.promoWasValid = false;
            // set the error message
            $scope.promoCodeError = data.error;
        });
    }
});
